import { executeApiCall } from 'services/api';
import { getLoaders } from 'entities/hooks/load';
import {
  FullUserSuggestion,
  SuggestionComment,
  SuggestionWithUser,
  UserSuggestion,
} from '../types';

export const userSuggestionLoaders = getLoaders({
  findSuggestion: {
    load: async ({ suggestionId }: { suggestionId: string }): Promise<FullUserSuggestion> => {
      return executeApiCall({
        path: `/feedback/suggestions/${suggestionId}`,

        method: 'get',
      });
    },
  },

  userSuggestions: {
    load: async ({ userId }: { userId: string }): Promise<UserSuggestion[]> => {
      return executeApiCall({
        path: `/feedback/suggestions/user/${userId}`,

        method: 'get',
      });
    },
  },

  allClosedSuggestions: {
    load: async (): Promise<SuggestionWithUser[]> => {
      return executeApiCall({
        path: `/feedback/suggestions/closed`,

        method: 'get',
      });
    },
  },

  allOpenSuggestions: {
    load: async (): Promise<SuggestionWithUser[]> => {
      return executeApiCall({
        path: `/feedback/suggestions/active`,

        method: 'get',
      });
    },
  },

  suggestionCommentHistory: {
    load: async ({ id }: { id: string }): Promise<SuggestionComment[]> => {
      return executeApiCall({
        path: `/feedback/suggestions/comments/history/${id}`,

        method: 'get',
      });
    },
  },
});
